import { RequiredRule, Validator } from 'devextreme-react/validator';
import { DateBox } from 'devextreme-react/date-box';
import { useContext } from 'react';
import { Field, Panel } from '../../../../layouts';
import { AR, OrderStatus } from '../../../../types/enums';
import { formatShortDate } from '../../../../utils/date-utils';
import { RetailOrderContext } from '../context/RetailOrderContext';

export default function DeliveredToStoreDatesPanel() {

	const { order, modifyOrder } = useContext(RetailOrderContext);

	const isOrderReadonly =
		order.details.orderStatusID === OrderStatus.Closed ||
		order.details.orderStatusID === OrderStatus.Cancelled ||
		order.details.orderStatusID === OrderStatus.Pending ||
		order.details.orderStatusID === OrderStatus.Hold;

	let dateRequired = order.details.activeARs.includes(AR.DealerToEnterCabinetPOReceivedDate);
	let dateReadOnly = !dateRequired;

	return (
		<Panel header={'Dates'} >

			<Field label={'Estimated Cabinet Delivery Date'}>
				{formatShortDate(order.details.estimatedCabinetDeliveryDate)}
			</Field>
			<Field label={'Scheduled Install Start Date'}>
				{formatShortDate(order.details.scheduledInstallStartDate)}
			</Field>
			<Field label={'Scheduled Install Completion Date'}>
				{formatShortDate(order.details.scheduledInstallCompletionDate)}
			</Field>
			<Field label={'Cabinet PO Received Date'}>
				<DateBox value={order.details.cabinetPOReceivedDate}
					onValueChanged={(e) => modifyOrder({ ...order.details, cabinetPOReceivedDate: e.value })}
					readOnly={dateReadOnly || isOrderReadonly}
					className={dateRequired ? 'required' : ''}
					min={order.details.roDate}
					max={new Date()}>
					<Validator>
						{dateRequired && order.modified &&
							<RequiredRule message={'Cabinet PO Received Date is required'} />}
					</Validator>
				</DateBox>
			</Field>
		</Panel>
	);
}
